import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP6ChurnedOvw202605: FaireAdPerformancePeriodEntity = {
  token: "perf_p6_churned_ovw_202605",
  type: "adPerformancePeriod",
  scope: "OVERVIEW",
  periodType: "RECEIPT",
  startDate: "2026-05-01",
  endDate: "2026-05-31",
  impressions: 60098,
  clicks: 1322,
  adsSpendDollars: 6069,
  budgetDollars: 6200,
  salesDollars: 11746,
  bestEstimateRoas: 1.94,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.98,
  newCustomersAcquired: 19,
  reorderConversions: 7,
  dataAvailableAtDate: "2026-06-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
